import { assessmentStateMap, specialWorkflowList } from './assessmentStateUtil';
function isValidToneSequence(toneSequence) {
    if (toneSequence.length === 0)
        return false;
    var isValid = true;
    for (var _i = 0, toneSequence_1 = toneSequence; _i < toneSequence_1.length; _i++) {
        var tone = toneSequence_1[_i];
        if (tone < 0 || tone > 3) {
            isValid = false;
            break;
        }
    }
    return isValid;
}
function hasNextState(state) {
    return state['ToneHeardNext0'] || state['ToneHeardNext1'] || state['ToneHeardNext2'] || state['ToneHeardNext3'];
}
/**
 * Checks if input params is valid in hearing profile
 * @param hearingProfileFile Hearing profile of device
 * @param frequency Frequency
 * @param toneSequence Hlaa tone sequence
 * @returns Returns true if frequency and tone sequence is valid
 */
export function isValidInput(hearingProfile, frequency, toneSequence) {
    if (!hearingProfile["".concat(frequency)]) {
        console.error('\nError: Invalid frequency input.');
        return false;
    }
    if (!isValidToneSequence(toneSequence)) {
        console.error('\nError: Invalid tone sequence input.');
        return false;
    }
    return true;
}
/**
 * Checks for the updated result state of hlaa
 * @param state Current hlaa state
 * @param count Count of hlaa steps
 * @param toneSequence Hlaa tone sequence
 * @returns Returns resulting state of hlaa
 */
export function checkUpdateResult(state, count, toneSequence) {
    var result = null;
    if (state['AssessmentState'] == 1) {
        result = { threshold: state['IdentifiedAudiogram'] };
    }
    else if (specialWorkflowList.includes(state['AssessmentState'])) {
        result = { workflow: assessmentStateMap[state['AssessmentState']] };
    }
    else if (count >= toneSequence.length || !hasNextState(state)) {
        result = {
            toneSet: state['ToneSet'],
            toneSetSequenceIndex: state['ToneSetSequenceIndex'],
            frequencyIndex: state['FrequencyIndex']
        };
    }
    return result;
}
